export function addCurrent(param) {
  return {
    type: 'ADD_CURRENT',
    param,
  }
}
